// src/menu/sections/dnsMenu.ts
import type { AppMenuEntry } from "../types";

export const DNS_MENU: AppMenuEntry = {
  type: "group",
  key: "dns",
  label: "DNS",
  children: [
    {
      key: "dnscontrol",
      label: "DNS Control",
      path: "/dnscontrol",
      componentKey: "dnsControl",
      icon: "home",
    },
    {
      key: "domains",
      label: "Domains",
      path: "/domains",
      resource: "domains",
      icon: "domains",
    },
    {
      key: "v_records",
      label: "V Records",
      path: "/v_records",
      resource: "v_records",
      icon: "records",
    },
    {
      key: "records",
      label: "Records",
      path: "/records",
      resource: "records",
      icon: "records",
    },
  ],
};
